module.exports = __webpack_public_path__ + "img/txws.6dc67308.jpg";